// deps
import React, { createContext, useContext, ReactElement, ReactNode } from "react";

// internal deps
import { ExpenseCodeHalfcard } from "@swiggy-private/payment-ui";

// hooks
import useExpenseCodeHalfcard, { IUseExpenseCodeHalfcardReturn } from "@payment-client/hooks/useExpenseCodeHalfcard";

const ExpenseCodeHalfCardContext = createContext<IUseExpenseCodeHalfcardReturn | null>(null);

interface ExpenseCodeHalfCardProviderProps {
    children: ReactNode;
}

export const ExpenseCodeHalfCardProvider = ({ children }: ExpenseCodeHalfCardProviderProps): ReactElement => {
    const {
        expenseCodeProps,
        showExpenseCodeHalfCard,
        onOpenHalfcard,
        setOnSubmit,
        isBillToCompanySelected,
        setIsFullPaymentMode,
        setSplitPaySelectedMethods,
        b2CHalfCardConfig,
    } = useExpenseCodeHalfcard();

    const contextValue: IUseExpenseCodeHalfcardReturn = {
        expenseCodeProps,
        showExpenseCodeHalfCard,
        onOpenHalfcard,
        setOnSubmit,
        isBillToCompanySelected,
        setIsFullPaymentMode,
        setSplitPaySelectedMethods,
        b2CHalfCardConfig,
    };

    return (
        <ExpenseCodeHalfCardContext.Provider value={contextValue}>
            {children}

            <ExpenseCodeHalfcard {...expenseCodeProps} />
        </ExpenseCodeHalfCardContext.Provider>
    );
};

export const useExpenseCodeHalfCardContext = (): IUseExpenseCodeHalfcardReturn => {
    const context = useContext(ExpenseCodeHalfCardContext);
    return context || ({} as IUseExpenseCodeHalfcardReturn);
};
